import React, { FC, useMemo } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../../store/selectors/currentDealSelectors';

const DepositPercentageContainer: FC = () => {
  const deposit = useSelector(currentDealSelectors.getFinanceDeposit) ?? 0;
  const totalPrice = useSelector(currentDealSelectors.getPrimaryPriceTotal) ?? 0;
  const DepositPercentage = useMemo(() => Math.round((deposit * 100) / totalPrice?.basePrice), [deposit, totalPrice]);

  return <Rate labelId={RateTypes.DEPOSIT_PERCENTAGE} value={`${DepositPercentage}%`} />;
};

export default DepositPercentageContainer;
